const KEY = 'rr_inspection_kiosk';
export const isKioskMode = () => localStorage.getItem(KEY) === '1';
export const enterKioskMode = () => { localStorage.setItem(KEY, '1'); };
export const exitKioskMode = () => { localStorage.removeItem(KEY); };
